/**
 * Sham Benefits Cards - Interaction Logic
 * Handles carousel navigation and "Learn More" toggle interactions.
 */

class ShamBenefitsCards extends HTMLElement {
    constructor() {
        super();
        this.scrollArea = this.querySelector('[data-sham-scroll-area]');
        this.prevBtn = this.querySelector('[data-sham-prev]');
        this.nextBtn = this.querySelector('[data-sham-next]');

        this.bindEvents();
        this.initScroll();
    }

    bindEvents() {
        // Navigation
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll('prev'));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll('next'));

        // Scroll Monitor
        if (this.scrollArea) {
            this.scrollArea.addEventListener('scroll', () => this.updateNavState(), { passive: true });
            // Initial check
            this.updateNavState();
        }

        // Card Toggles (Delegate)
        this.addEventListener('click', (e) => {
            const toggleBtn = e.target.closest('.sham-card-toggle-btn');
            if (toggleBtn) {
                e.preventDefault();
                this.toggleCard(toggleBtn);
            }
        });
    }

    initScroll() {
        // Resize observer to update nav state on window resize
        const resizeObserver = new ResizeObserver(() => this.updateNavState());
        if (this.scrollArea) resizeObserver.observe(this.scrollArea);
    }

    scroll(direction) {
        if (!this.scrollArea) return;

        const cardWidth = this.getCardWidth();
        const gap = 24; // var(--sham-space-6) approx, or computed
        const scrollAmount = cardWidth + gap;

        const currentScroll = this.scrollArea.scrollLeft;
        const targetScroll = direction === 'next'
            ? currentScroll + scrollAmount
            : currentScroll - scrollAmount;

        this.scrollArea.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    }

    getCardWidth() {
        const card = this.querySelector('.sham-card');
        return card ? card.offsetWidth : 300;
    }

    updateNavState() {
        if (!this.scrollArea || !this.prevBtn || !this.nextBtn) return;

        const { scrollLeft, scrollWidth, clientWidth } = this.scrollArea;

        // Tolerance for float math
        const isStart = scrollLeft <= 2;
        const isEnd = Math.abs(scrollWidth - clientWidth - scrollLeft) <= 2;
        const isScrollable = scrollWidth > clientWidth;

        this.prevBtn.disabled = isStart || !isScrollable;
        this.nextBtn.disabled = isEnd || !isScrollable;
    }

    toggleCard(btn) {
        const card = btn.closest('.sham-card');
        if (!card) return;

        const isActive = card.classList.contains('is-active');

        // Close others? Optional constraint. Keeping multiple open allowed for now.
        // If we wanted accordion style:
        // this.querySelectorAll('.sham-card.is-active').forEach(c => {
        //   if(c !== card) this.closeCard(c);
        // });

        if (isActive) {
            this.closeCard(card, btn);
        } else {
            this.openCard(card, btn);
        }
    }

    openCard(card, btn) {
        card.classList.add('is-active');

        const wrapper = card.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.add('is-expanded');

        // Update Button Text
        const textSpan = btn.querySelector('.sham-btn__text');
        if (textSpan) textSpan.textContent = 'Close';
    }

    closeCard(card, btn) {
        card.classList.remove('is-active');

        const wrapper = card.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.remove('is-expanded');

        // Update Button Text
        const textSpan = btn.querySelector('.sham-btn__text');
        if (textSpan) textSpan.textContent = 'Learn More';
    }
}

customElements.define('sham-benefits-cards', ShamBenefitsCards);
